import { useMemo } from "react";
import { routes } from "../../../app/routes";

import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";
import { useUrlParams } from "../../../hooks";

export const HostTenantTopbar = (props: any) => {
  const id = useUrlParams("id");

  const submenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Back",
        icon: IconDefinitions.back,
        url: routes.host.tenant.index,
      },
      {
        label: "Details",
        icon: IconDefinitions.squareInfo,
        url: routes.host.tenant.details,
        activeMatch: routes.host.tenant.details,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Organizations",
        icon: IconDefinitions.organization,
        url: routes.host.tenant.organization,
        activeMatch: routes.host.tenant.organization,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Features",
        icon: IconDefinitions.gear,
        url: routes.host.tenant.features,
        activeMatch: routes.host.tenant.features,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      ],
    [id]
  );

  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default HostTenantTopbar;

